import React from 'react';
import { Box, Typography } from '@mui/material';
import StatBox from './StatBox';
import { SHARED_TYPOGRAPHY } from '../../../theme';

/**
 * MetricSection Component
 *
 * Displays a section with title and a grid of StatBox components
 * Used for repeated metric display patterns throughout the dashboard
 */
const MetricSection = ({
  title,
  metrics = [],
  gridColumns = '1fr 1fr',
  gap = 1,
  mb = 1,
}) => {
  return (
    <Box sx={{ mb }}>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{
          ...SHARED_TYPOGRAPHY.bodyBoldSecondary,
          mb: 0.5,
          textAlign: 'left',
        }}
      >
        {title}
      </Typography>
      <Box
        display="grid"
        gap={gap}
        sx={{
          gridTemplateColumns:
            typeof gridColumns === 'object' ? gridColumns : gridColumns,
        }}
      >
        {metrics.map(metric => (
          <StatBox
            key={metric.label}
            value={metric.value}
            label={metric.label}
            color={metric.color}
            valueVariant={metric.valueVariant || 'h6'}
            flex={metric.flex}
            sx={metric.sx}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MetricSection;
